import { Address } from './address';
import { Buyer } from './buyer';

export class Pharmacy {
  HIN: any;
  addresses: Address[];
  buyers: Buyer[];
  company_id: number;
  contact_email: string;
  contact_name: string;
  contact_phone: string;
  dea_number: string;
  delivery_address: Address;
  email: string;
  id: number;
  is_new?: boolean;
  is340b: boolean;
  license: any;
  name: string;
  npi_number: any;
  original_delivery_address: Address;
  past_due: any;
  phone: string;
  state_license: string;
  state_license_exp: string;
  state_license_expiration: string;
  state_license_number: string;
  type: string;
  type_other: any;
  vetted: boolean;
}

export class Pharmacies {
  data: Pharmacy[];
  error?: any;
}

export const pharmacy_default: Pharmacy = {
  HIN: null,
  addresses: null,
  buyers: [],
  company_id: null,
  contact_email: '',
  contact_name: '',
  contact_phone: '',
  dea_number: '',
  email: '',
  id: null,
  is_new: true,
  is340b: false,
  license: null,
  npi_number: '',
  original_delivery_address: null,
  past_due: '',
  phone: '',
  state_license: '',
  state_license_exp: '',
  state_license_expiration: '',
  state_license_number: '',
  type: '',
  type_other: '',
  vetted: false,
  name: '',
  delivery_address: {
    id: null,
    country: '',
    line_1: '',
    line_2: '',
    line_3: '',
    city: '',
    state: '',
    postal_code: '',
    notes: '',
    type: '',
  },
};
